import { Divider, Grid, Select, TextInput, Title } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form/lib/use-form";
import { cities, provinces } from "../../../../data/province-city.array";
import { MerchantOnboardingFormValues } from "../../../../type/merchant-onboarding-form-values.types";
import PhoneCountryCodeIcon from "../../../icons/phone-country-code-icon.component";

interface MainOfficeContactInfoProps {
  form: UseFormReturnType<MerchantOnboardingFormValues>;
}
function MainOfficeContactInfo(props: MainOfficeContactInfoProps) {
  const { form } = props;

  const label = {
    mainOfficeContactNumber: "Main office contact number",
    mainOfficeBldgNameNo: "Main office building name and number",
    mainOfficeStreetAddress: "Main office street address",
    mainOfficeBarangay: "Main office barangay",
    mainOfficeCity: "Main office city",
    mainOfficeProvince: "Main office province",
    mainOfficePostalCode: "Main office postal code",
  };
  const placeHolder = {
    mainOfficeBldgNameNo: "Building name and number",
    mainOfficeStreetAddress: "Street address",
    mainOfficeBarangay: "Barangay",
    mainOfficeCity: "City",
    mainOfficeProvince: "Province",
    mainOfficePostalCode: "Postal code",
  };
  return (
    <>
      <Grid>
        <Grid.Col>
          <Title order={3}>Main Office Contact Information</Title>
        </Grid.Col>
        <Grid.Col>
          <TextInput
            label={label.mainOfficeContactNumber}
            value={form.values.mainOfficeContactNumber}
            icon={<PhoneCountryCodeIcon />}
            iconWidth={48}
            onChange={(event) => {
              form.setFieldValue(
                "mainOfficeContactNumber",
                event.currentTarget.value
              );
            }}
            error={form.errors.mainOfficeContactNumber}
            data-cy="mainOfficeContactNumber"
          />
        </Grid.Col>
        <Grid.Col>
          <TextInput
            placeholder={placeHolder.mainOfficeBldgNameNo}
            label={label.mainOfficeBldgNameNo}
            value={form.values.mainOfficeBldgNameNo}
            onChange={(event) => {
              form.setFieldValue(
                "mainOfficeBldgNameNo",
                event.currentTarget.value
              );
            }}
            error={form.errors.mainOfficeBldgNameNo}
            data-cy="mainOfficeBldgNameNo"
          />
        </Grid.Col>
        <Grid.Col>
          <TextInput
            placeholder={placeHolder.mainOfficeStreetAddress}
            label={label.mainOfficeStreetAddress}
            value={form.values.mainOfficeStreetAddress}
            onChange={(event) => {
              form.setFieldValue(
                "mainOfficeStreetAddress",
                event.currentTarget.value
              );
            }}
            error={form.errors.mainOfficeStreetAddress}
            data-cy="mainOfficeStreetAddress"
          />
        </Grid.Col>

        <Grid.Col xs={12} sm={6}>
          <Select
            label={label.mainOfficeProvince}
            placeholder={placeHolder.mainOfficeProvince}
            data={provinces}
            value={form.values.mainOfficeProvince}
            onChange={(value: string) => {
              form.setFieldValue("mainOfficeProvince", value);
              form.setFieldValue("mainOfficeCity", "");
            }}
            searchable
            nothingFound="No options"
            error={form.errors.mainOfficeProvince}
            data-cy="mainOfficeProvince"
          />
        </Grid.Col>
        <Grid.Col xs={12} sm={6}>
          <Select
            label={label.mainOfficeCity}
            placeholder={placeHolder.mainOfficeCity}
            data={
              form.values.mainOfficeProvince.length > 0
                ? cities[form.values.mainOfficeProvince]
                : []
            }
            disabled={form.values.mainOfficeProvince === ""}
            searchable
            nothingFound="No options"
            value={form.values.mainOfficeCity}
            onChange={(value: string) => {
              form.setFieldValue("mainOfficeCity", value);
            }}
            error={form.errors.mainOfficeCity}
            data-cy="mainOfficeCity"
          />
        </Grid.Col>
        <Grid.Col xs={12} md={6}>
          <TextInput
            placeholder={placeHolder.mainOfficeBarangay}
            label={label.mainOfficeBarangay}
            value={form.values.mainOfficeBarangay}
            onChange={(event) => {
              form.setFieldValue(
                "mainOfficeBarangay",
                event.currentTarget.value
              );
            }}
            error={form.errors.mainOfficeBarangay}
            data-cy="mainOfficeBarangay"
          />
        </Grid.Col>
        <Grid.Col xs={12} md={6}>
          <TextInput
            placeholder={placeHolder.mainOfficePostalCode}
            label={label.mainOfficePostalCode}
            value={form.values.mainOfficePostalCode}
            onChange={(event) => {
              form.setFieldValue(
                "mainOfficePostalCode",
                event.currentTarget.value
              );
            }}
            error={form.errors.mainOfficePostalCode}
            data-cy="mainOfficePostalCode"
          />
        </Grid.Col>
        <Grid.Col>
          <Divider my="md" />
        </Grid.Col>
      </Grid>
    </>
  );
}

export default MainOfficeContactInfo;
